// src/sections/Store.js
import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './Store.css';
import { gsap } from 'gsap';

// 画像をインポート
import item1Img from '../assets/KoukakuKidoutai_ArtCollection_1.jpg';
import item2Img from '../assets/Fuzichoco_TokimekiCollection.png';
import item3Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_1.jpg';
import item4Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_2.jpg';
import item5Img from '../assets/KoukakuKidoutai_ArtCollection_2.jpg';

// ループ時に画像が繰り返されるのを避けるため、既存の画像を再利用しつつ、IDはユニークに
import item6Img from '../assets/KoukakuKidoutai_ArtCollection_1.jpg';
import item7Img from '../assets/Fuzichoco_TokimekiCollection.png';
import item8Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_1.jpg';
import item9Img from '../assets/IdentityV_CreatorCollab_KyotoNEO_2.jpg';
import item10Img from '../assets/KoukakuKidoutai_ArtCollection_2.jpg';


const storeItems = [
  { id: 1, name: '攻殻機動隊 アートコレクション', image: item1Img },
  { id: 2, name: '藤ちょこ先生TOKIMEKIコレクション', image: item2Img },
  { id: 3, name: '第五人格 クリエイターコラボKYOTO NEO', image: item3Img },
  { id: 4, name: '第五人格 クリエイターコラボKYOTO NEO', image: item4Img },
  { id: 5, name: '攻殻機動隊 アートコレクション', image: item5Img },
  { id: 6, name: '攻殻機動隊 アートコレクション', image: item6Img },
  { id: 7, name: '藤ちょこ先生TOKIMEKIコレクション', image: item7Img },
  { id: 8, name: '第五人格 クリエイターコラボKYOTO NEO', image: item8Img },
  { id: 9, name: '第五人格 クリエイターコラボKYOTO NEO', image: item9Img },
  { id: 10, name: '攻殻機動隊 アートコレクション', image: item10Img },
];

const ItemCard = ({ item }) => {
  const cardRef = useRef(null);

  const handleMouseEnter = () => {
    gsap.to(cardRef.current, { scale: 1.05, duration: 0.3 });
  };

  const handleMouseLeave = () => {
    gsap.to(cardRef.current, { scale: 1, duration: 0.3 });
  };

  return (
    <div className="item-card" ref={cardRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="item-image-container">
        <img src={item.image} alt={item.name} className="item-image" />
      </div>
      <p className="item-name">{item.name}</p>
    </div>
  );
};


function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} arrow-button slick-next-custom`}
      onClick={onClick}
    >
      <span className="arrow-icon"></span>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} arrow-button slick-prev-custom`}
      onClick={onClick}
    >
      <span className="arrow-icon"></span>
    </div>
  );
}


function Store() {
  const sliderRef = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 5,
    infinite: true,
    speed: 500,
    dots: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px',
        }
      }
    ]
  };

  return (
    <section id="store" className="store-section">
      <h2 className="section-title">STORE</h2>
      <div className="store-carousel-container">
        <Slider ref={sliderRef} {...settings}>
          {storeItems.map(item => (
            <div key={item.id}>
              <ItemCard item={item} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Store;